<div class="content-wrapper" style="margin-bottom: 100px">
  <div
    class="col-md-12 layout-spacing"
    style="margin-top: 30px; display: flex; flex-direction: column; gap: 30px"
  >
    <div class="row" style="height: 60vh">
      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="no-gutters row" style="height: 100%">
            <div class="row" style="height: 100%">
              <div class="col-md-5 custom-manual">
                <div class="new-arrival-product">
                  <div class="new-arrivals-img-contnent">
                    <img
                      [src]="
                        currentLang == 'es'
                          ? 'assets/img/manuals/SGS09F01-es.png'
                          : 'assets/img/manuals/SGS09F01-en.png'
                      "
                      alt="Skote"
                      class="img-fluid card-img"
                    />
                  </div>
                </div>
                <a
                  [href]="
                    currentLang == 'es'
                      ? '/assets/manuals/SGS09F01-Politica-clasificacion-reglas-uso.pdf'
                      : '/assets/manuals/SGS09F01-Classification-policies-rules-of-use.pdf'
                  "
                  target="_blank"
                  class="btn btn-primary btn-rounded mt-4"
                  >{{ 'record.download.download' | translate }}</a
                >
              </div>
              <div class="col-md-7">
                <div class="card-body">
                  <div class="card-title text-bold">
                    <a
                      href="/assets/manuals/SGS09F01-Politica-clasificacion-reglas-uso.pdf"
                      target="_blank"
                    >
                      <h5>{{ 'manual.procedures.left.title' | translate }}</h5>
                    </a>
                  </div>
                  <p class="card-text">
                    <small class="text-muted">{{
                      'manual.procedures.left.author' | translate
                    }}</small>
                  </p>
                  <p class="card-text">
                    {{ 'manual.procedures.left.description' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="no-gutters row" style="height: 100%">
            <div class="row" style="height: 100%">
              <div class="col-md-5 custom-manual">
                <div class="new-arrival-product">
                  <div class="new-arrivals-img-contnent">
                    <img
                      [src]="
                        currentLang == 'es'
                          ? 'assets/img/manuals/SGS09F02-es.png'
                          : 'assets/img/manuals/SGS09F02-en.png'
                      "
                      alt="Skote"
                      class="img-fluid card-img"
                    />
                  </div>
                </div>
                <a
                  [href]="
                    currentLang == 'es'
                      ? '/assets/manuals/SGS09F02-Intercambio-seguro-informacion.pdf'
                      : '/assets/manuals/SGS09F02-Secure-exchange-of-information.pdf'
                  "
                  target="_blank"
                  class="btn btn-primary btn-rounded mt-4"
                  >{{ 'record.download.download' | translate }}</a
                >
              </div>
              <div class="col-md-7">
                <div class="card-body">
                  <div class="card-title text-bold">
                    <a
                      href="/assets/manuals/SGS09F02-Intercambio-seguro-informacion.pdf"
                      target="_blank"
                    >
                      <h5>{{ 'manual.procedures.right.title' | translate }}</h5>
                    </a>
                  </div>
                  <p class="card-text">
                    <small class="text-muted">{{
                      'manual.procedures.right.author' | translate
                    }}</small>
                  </p>
                  <p class="card-text">
                    {{ 'manual.procedures.right.description' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="height: 60vh">
      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="no-gutters row" style="height: 100%">
            <div class="row" style="height: 100%">
              <div class="col-md-5 custom-manual">
                <div class="new-arrival-product">
                  <div class="new-arrivals-img-contnent">
                    <img
                      [src]="
                        currentLang == 'es'
                          ? 'assets/img/manuals/Manual-Usuario.png'
                          : 'assets/img/manuals/User-Manual.png'
                      "
                      alt="Skote"
                      class="img-fluid card-img"
                    />
                  </div>
                </div>
                <a
                  [href]="
                    currentLang == 'es'
                      ? '/assets/manuals/SafeCloud-Manual-usuario.pdf'
                      : '/assets/manuals/SafeCloud-User-Manual.pdf'
                  "
                  target="_blank"
                  class="btn btn-primary btn-rounded mt-4"
                  >{{ 'record.download.download' | translate }}</a
                >
              </div>
              <div class="col-md-7">
                <div class="card-body">
                  <div class="card-title text-bold">
                    <a
                      [href]="
                        currentLang == 'es'
                          ? '/assets/manuals/SafeCloud-Manual-usuario.pdf'
                          : '/assets/manuals/SafeCloud-User-Manual.pdf'
                      "
                      target="_blank"
                    >
                      <h5>{{ 'manual.procedure.title' | translate }}</h5>
                    </a>
                  </div>
                  <p class="card-text">
                    <small class="text-muted">{{
                      'manual.procedure.author' | translate
                    }}</small>
                  </p>
                  <p class="card-text">
                    {{ 'manual.procedure.description' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
